import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from '../axios';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import HeaderSecond from '../HeaderSecond';
import LoaderImg from '../img/logo/running.gif';
import Footer from '../Footer';

const EventPrivacyPolicy = () => {
  // console.log("Create Event page");
  const [Loader, setLoader] = useState(false);
  const [EventPrivacyPolicy, setEventPrivacyPolicy] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoader(true);
    axios.post("event_privacy_policy")
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          setEventPrivacyPolicy(response.data.data.EventPrivacyPolicy ? response.data.data.EventPrivacyPolicy[0].content : []);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      })
  }, [])
  // console.log(EventPrivacyPolicy);
  
  return (
    <>
      {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}
      <ToastContainer theme="colored" />

      <HeaderSecond />
      <main className="main__content_wrapper">
        {/* Start breadcrumb section */}
        <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
          <div className="container">
            <div className="row row-cols-1">
              <div className="col">
                <div className="breadcrumb__content">
                  <h1 className="breadcrumb__content--title text-white mb-10">
                  Event Privacy Policy
                  </h1>
                  
                  {/* <ul className="breadcrumb__content--menu d-flex">
                    <li className="breadcrumb__content--menu__items">
                      <div className="text-white" onClick={(e) => handleBackToHome(e)}>
                        Home
                      </div>
                    </li>
                    <li className="breadcrumb__content--menu__items">
                      <span className="text-white">Privacy Policy</span>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End breadcrumb section */}

        <section className="section--padding pt-5">
          <div className="container">
            <div className="row">
                <div className="col-sm-12 my-5" style={{textAlign: "justify"}}>
                    <div dangerouslySetInnerHTML={{ __html: EventPrivacyPolicy }} />
                </div>
            </div>

          </div>
        </section>

      </main >
      <Footer />
    </>
  )
}

export default EventPrivacyPolicy;

